import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import i18n from 'i18n-js';
import { buildUrl } from 'utils';
import { Card } from 'components/UI';
import PeriodsList from './PeriodsList';
import Loading from 'components/Loading';
import { useHistory } from 'react-router-dom';
import { useStyles } from './PeriodsListWidget.styled';
import { Box, Typography, Button } from '@material-ui/core';
import { SubscriptionsActions } from 'state/modules/subscriptions';

const PeriodsListWidget = ({ id, customParams }) => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  const { periods, periodsPagination, fetchingSubscriptionsPeriods } = useSelector(
    (state) => state.subscriptions
  );

  const [params, setParams] = useState({
    page: 1,
    limit: 3,
    ...customParams,
  });

  const fetchSubscriptionsPeriods = useCallback(
    (params = {}) => {
      dispatch(SubscriptionsActions.fetchSubscriptionsPeriods(params));
    },
    [dispatch]
  );

  useEffect(() => {
    fetchSubscriptionsPeriods(params);
  }, [fetchSubscriptionsPeriods, params]);

  const handlePageChange = (e, page) => {
    const newParams = { page: page + 1, limit: params.limit };
    setParams({ ...params, ...newParams });
  };

  const viewAll = () => {
    history.push(
      buildUrl(`/subscriptions/reservation-periods?subscription_id=${customParams.subscription_id}`)
    );
  };

  const title = (
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <Typography color="textPrimary" component="span">
        <Box fontSize={14} fontWeight="fontWeightMedium" data-cy="periods-widget-title">
          {i18n.t('subscriptions.periods_invoices')}
        </Box>
      </Typography>
      <Button
        type="button"
        variant="text"
        color="primary"
        onClick={viewAll}
        disableFocusRipple={true}
        data-cy="view-all-periods"
        className={classes.button}
      >
        {i18n.t('common.view_all')}
      </Button>
    </Box>
  );

  return (
    <Card title={title} headerActionType="vertical">
      {fetchingSubscriptionsPeriods ? (
        <Box
          className={classes.loadingContainer}
          justifyContent="center"
          alignItems="center"
          display="flex"
        >
          <Loading />
        </Box>
      ) : (
        <>
          <PeriodsList
            data={periods}
            params={params}
            pagination={periodsPagination}
            handleChangePage={handlePageChange}
          />
        </>
      )}
    </Card>
  );
};

PeriodsListWidget.propTypes = {
  title: PropTypes.string.isRequired,
  isCustomer: PropTypes.bool.isRequired,
  type: PropTypes.oneOf(['vehicle', 'customer', 'user']).isRequired,
};

PeriodsListWidget.defaultProps = {
  title: '',
  type: 'vehicle',
  isCustomer: false,
};

export default PeriodsListWidget;
